export const configurePolaris = (signIn, signOut) => {
  const header = document.querySelector('xc-header');
  if (header) {
    // this is used to configure the polaris header, and NOT src/elements/xhs-shared/js/polaris/config.js
    header.setAttribute('sign-in-url', signIn);
    header.setAttribute('sign-out-url', signOut);
    header.setAttribute('enable-account-selector', 'true');
  }
};
